import React from "react";
import { Badge } from "reactstrap";
import "./question.scss";
import CustomChip from "../chip";

class YesNoQuestion extends React.Component {
  state = {
    device: "mobile",
    answer: true,
  };
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web",
    });
  }
  render() {
    return (
      <div className="question-container">
        <h3 className="font-weight-bold mb-24 mb-mobile-24">
          {this.props.title}
        </h3>
        {this.props.subTitle && (
          <h3 className=" mb-24 mb-mobile-24">{this.props.subTitle}</h3>
        )}
        <div className="chip-div">
          <CustomChip
            title="Yes"
            iconClass={"fa-check"}
            checked={this.state.answer}
            onChecked={(value) => {
              this.setState({
                answer: value,
              });
            }}
          />
          &nbsp; &nbsp;
          <CustomChip
            title="No"
            iconClass={"fa-times"}
            checked={!this.state.answer}
            onChecked={(value) => {
              this.setState({
                answer: !value,
              });
            }}
          />
        </div>
      </div>
    );
  }
}

export default YesNoQuestion;
